<template>
    <div>
        <div class="custom-conditions">
            <div class="actions-bar">
                <label class="switch">
                    <input type="checkbox" id="editCondition" v-model="editCondition">
                    <div class="slider"></div>
                    <p>{{ $t('conditions.edit-condition.label') }}</p>
                </label>
                <div class="button-container">
                    <router-link to="/user/settings#§11-vilkår" target="_blank" class="button transparent">{{
                        $t('conditions.edit-template.label') }}</router-link>
                    <button class="button transparent" @click="reset">{{ $t('conditions.reset-template.label') }}
                    </button>
                </div>
            </div>
            <div class="input-container">
                <textarea
                        class="textarea-authoheight"
                        id="specialConditionsCustomTextarea"
                        v-show="editCondition"
                        :value="value"
                        @input="$emit('input', $event.target.value)"
                ></textarea>
                <div class="text" v-show="!editCondition" id="specialConditionsCustomDiv">{{ value }}</div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomTextConditions",
        props: {
            value: String,
            defaultText: String
        },
        data() {
            return {
                editCondition: this.value !== this.defaultText,
                hiddenDiv: null
            }
        },
        methods: {
            reset: function () {
                this.$emit('input', this.defaultText);
                this.editCondition = false;
            },
            nl2br: function (str) {
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
            },
            autoExpand: function () {

                let textarea = document.getElementById('specialConditionsCustomTextarea');

                // Workaround with DIV tag to avoid flashes while resizing a textarea

                var computed = window.getComputedStyle(textarea);

                // Every input/change, grab the content
                let content = textarea.value;

                // Add the same content to the hidden div

                // This is for old IE
                content = content.replace(/\n/g, '<br>');

                // The <br ..> part is for old IE
                // This also fixes the jumpy way the textarea grows if line-height isn't included
                this.hiddenDiv.innerHTML = content + '<br style="line-height:' + this.hiddenDiv.style.lineHeight + '">';

                textarea.style.height = (this.hiddenDiv.offsetHeight - 32) + 'px';
            }
        },
        watch: {
            editCondition: function (checked) {
                if (!checked) {
                    this.reset();
                }
            },
            value: function () {
                this.autoExpand();
            }
        },
        beforeUpdate() {
            if(this.editCondition) {
                let textarea = document.getElementById('specialConditionsCustomTextarea');
                let div = document.getElementById('specialConditionsCustomDiv');
                textarea.style.height = (div.offsetHeight - 32) + 'px';
            }
        },
        mounted() {
            let div = document.createElement("div");
            div.id = 'taHiddenDiv';

            let width = document.getElementsByClassName('sidebar-container')[0].offsetWidth +
                document.getElementsByClassName('overview-nav')[0].offsetWidth;

            div.style.width = 'calc(100% - ' + (width - 32) + 'px)';

            document.body.appendChild(div);

            this.hiddenDiv = div;

            if(this.editCondition) {
                setTimeout(this.autoExpand, 0)
            }
        }
    }
</script>

<style lang="scss">

    .textarea-authoheight {
        -webkit-transition: height 200ms;
        -moz-transition: height 200ms;
        -ms-transition: height 200ms;
        -o-transition: height 200ms;
        transition: height 200ms;
        overflow: hidden;
        resize: none;
    }

    #taHiddenDiv {
        display: block;
        white-space: pre-wrap;
        word-wrap: break-word;
        position: absolute;
        visibility: hidden;
        max-width: calc(800px - 30px);
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        font-size: 16px;
        padding: 15px;
        font-family: HankenGroteskRegular, HankenGroteskRegularOld, HelveticaNeue, Helvetica, Arial, sans-serif;
        margin-bottom: 40px;
        line-height: 1.5;
        top: -10000px;
        left: -10000px;
    }

    .text {
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>
